import React, { Component } from "react";

class Footer extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <>
                {/* Footer Start */}
                <footer className="footer">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col text-md-end">
                                © Dachepalli publications {new Date().getFullYear()}
                            </div>
                            {/* <div className="col-md-6">
                                <div className="text-md-end footer-links d-none d-md-block">
                                    <a href="javascript: void(0);">About</a>
                                    <a href="javascript: void(0);">Support</a>
                                    <a href="javascript: void(0);">Contact Us</a>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </footer>
                {/* end Footer */}

            </>
        )
    }
}

export default Footer;